import { useEffect } from "react"
import { useQueryEndpoint } from "../hooks/QueryHooks"
import { CACHE_WARMUP_ENDPOINT, LATEST_API_VERSION } from "./Constants"
import { setQueryParameters } from "../pages/sub-components/SetQueryParameters"
import { getThisLastDateRange } from "./util"
import { useFilterAtomValue } from "../hooks/FilterHooks"
import { usePartnerAtomValue } from "../hooks/PartnerHooks"
import LoadingWrapper from "../components/Loading/LoadingWrapper"
import LoadingSpinner from "../components/Loading/LoadingSpinner"
import { useAtomValue } from "jotai"
import { userAtom } from "../atoms/user"

export const WarmCache = ({setInitialized}) => {
	const params = setQueryParameters()
	const filterDataValue = useFilterAtomValue()
	const dateRangeCalc = getThisLastDateRange(filterDataValue)
	const partner = usePartnerAtomValue()
	const user = useAtomValue(userAtom)

	// For admin users, only enable API call if partner is selected
	// For non-admin users, always enable
	const shouldEnableQuery = user.isAdmin ? Boolean(partner) : true

	const { error, loaded, isFetching } = useQueryEndpoint(CACHE_WARMUP_ENDPOINT, null, "POST", {
		"api-version": LATEST_API_VERSION,
		...params,
		dateFrom: dateRangeCalc.this.dateFrom,
		dateTo: dateRangeCalc.this.dateTo,
		previousDateFrom: dateRangeCalc.last.dateFrom,
		previousDateTo: dateRangeCalc.last.dateTo
	}, shouldEnableQuery)

	useEffect(() => {
		setInitialized(false)
	}, [setInitialized])

	useEffect(() => {
		// For admin users without partner selection, set initialized to true to show the UI
		// but no data will be loaded
		if (user.isAdmin && !partner) {
			setInitialized(true)
		} else if (loaded && !error) {
			setInitialized(true)
		}
	}, [loaded, error, setInitialized, user.isAdmin, partner])

	// Show message for admin users who haven't selected a partner
	if (user.isAdmin && !partner) {
		return (
			<div style={{
				padding: '20px',
				textAlign: 'center',
				backgroundColor: '#f5f5f5',
				borderRadius: '8px',
				margin: '20px',
				border: '1px solid #ddd'
			}}>
				<h3 style={{ marginBottom: '10px', color: '#333' }}>Please select a partner code</h3>
				<p style={{ color: '#666' }}>Select a partner code from the dropdown above to view data.</p>
			</div>
		)
	}

    return (
        <>
            {isFetching && <h2>Fetching data, please hold...</h2> }
            <LoadingWrapper loaded={loaded} error={error} loadingComponent={<LoadingSpinner margin={0} />}></LoadingWrapper>
        </>
    )
}